import create from 'zustand';
import * as Operations from './factory';

export const useOps = create(Operations.create);
